<aslib-title></aslib-title>

<form novalidate [formGroup]='formCadastroValorMensalDistribuir'>
  <div class="form-group row">
    <label for="" class="col-md-3 text-right">Mês/Ano de referência:<span style="color: red;">*</span></label>
    <div class="controls col-md-2">
      <input type="text" appMonthYear placeholder="MM/AAAA" [(ngModel)]="dataReferenciaDistribuicao" required 
        formControlName="dataReferenciaDistribuicao" class="form-control" />
    </div>
  </div>
  <div class="form-group row">
    <label for="" class="col-md-3 text-right">Valor Royalties a Distribuir:<span style="color: red;">*</span></label>
    <div class="controls col-md-2">
      <input type="text" [(ngModel)]="valorMensalDistribuicao" placeholder="R$ 0,00" maxlength="17" appCurrencyMask inputmode="numeric" required 
        formControlName="valorMensalDistribuicao" class="form-control" />
    </div>
  </div>

  <div class="form-group row">
    <div class="controls col-md-4 offset-md-3">
      <button type="submit" class="btn btn-primary"  [disabled]="!formCadastroValorMensalDistribuir.valid" (click)="salvarValorMensalDistribuicao(modalMensagem)" >
        <aslib-icon type="1" icon="fa fa-check"></aslib-icon>Salvar </button>
    <button type="submit" class="btn btn-primary" (click)="limparConsulta()" >
        <aslib-icon type="1" icon="fa fa-refresh"></aslib-icon>Limpar </button>
      <button type="button" class="btn btn-primary" (click)="irPraConsulta()"  >
        <aslib-icon type="1" icon="fa fa-ban"></aslib-icon>Cancelar
      </button>
    </div>
    
  </div>

</form>
<aslib-modal #modalMensagem></aslib-modal>



// WEBPACK FOOTER //
// ./src/app/royalts/valor-mensal-distribuir/cadastra-valor-mensal-distribuir.component.html